var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "deliverable",
      attrs: { type: "button" },
      on: {
        click: function($event) {
          return _vm.$emit("open-deliverable")
        }
      }
    },
    [
      _c("strong", [_vm._v(_vm._s(_vm.deliverable.name))]),
      _c("span", { staticClass: "deliverable-meta" }, [
        _c(
          "span",
          [
            _c("portal-icon", {
              attrs: { name: "message-circle-question", size: 14 }
            }),
            _vm._v(
              " " +
                _vm._s(_vm.commentCount) +
                " " +
                _vm._s(_vm.$t("projects.comments")) +
                " "
            )
          ],
          1
        ),
        _c(
          "span",
          [
            _c("portal-icon", { attrs: { name: "folder-open", size: 14 } }),
            _vm._v(
              " " +
                _vm._s(_vm.fileCount) +
                " " +
                _vm._s(_vm.$t("projects.attachments")) +
                " "
            )
          ],
          1
        ),
        _vm.deliverable.dueDate
          ? _c(
              "span",
              [
                _c("portal-icon", {
                  attrs: { name: "calendar-days", size: 14 }
                }),
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("projects.due")) +
                    " " +
                    _vm._s(
                      _vm.DateTime.fromISO(_vm.deliverable.dueDate).toFormat(
                        "DD"
                      )
                    ) +
                    " "
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _c(
        "span",
        { staticClass: "deliverable-footer" },
        [
          _vm.deliverable.approvalRequestedAt
            ? _c(
                "portal-status-pill",
                {
                  attrs: {
                    background: "var(--v-blue_10-base)",
                    color: "var(--portal-text)"
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("projects.requested")) +
                      " " +
                      _vm._s(
                        _vm.DateTime.fromISO(
                          _vm.deliverable.approvalRequestedAt
                        ).toFormat("DD")
                      ) +
                      " "
                  )
                ]
              )
            : _vm._e(),
          _vm.lastApproval && !_vm.deliverable.approvalRequired
            ? _c(
                "portal-status-pill",
                {
                  attrs: {
                    background: "var(--v-success_10-base)",
                    color: "var(--v-success-base)"
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("projects.submitted")) +
                      " " +
                      _vm._s(
                        _vm.DateTime.fromISO(
                          _vm.lastApproval.approvedAt
                        ).toFormat("DD")
                      ) +
                      " "
                  )
                ]
              )
            : _vm._e(),
          _c("portal-icon", { attrs: { name: "chevron-right", size: 16 } })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }